var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var UPDATE_ACCOUNT_DETAILS = "UPDATE_ACCOUNT_DETAILS";
var initState = {
    accTyp: "",
    userID: "",
    emaildId: "",
    accountCode: "",
    lgnSrc: "",
    isImpersonated: null,
    userName: "",
    empOrDependent: "",
    productsAlias: [],
    prefAccTyp: ""
};
export default function accountDetailsReducer(state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case UPDATE_ACCOUNT_DETAILS:
            return __assign({}, action.payload);
        default:
            return state;
    }
}
